import { render, staticRenderFns } from "./CatalogFilter.vue?vue&type=template&id=129cde72&scoped=true&"
import script from "./CatalogFilter.vue?vue&type=script&lang=js&"
export * from "./CatalogFilter.vue?vue&type=script&lang=js&"
import style0 from "./CatalogFilter.vue?vue&type=style&index=0&id=129cde72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129cde72",
  null
  
)

export default component.exports